(function () {
  const drawer = document.querySelector('[data-af-nav-drawer]');
  const toggle = document.querySelector('[data-af-nav-toggle]');
  const backdrop = document.querySelector('[data-af-nav-backdrop]');
  if (!drawer || !toggle) return;

  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('af-nav-open');
    if (backdrop) backdrop.setAttribute('hidden', '');
  };

  const open = () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('af-nav-open');
    if (backdrop) backdrop.removeAttribute('hidden');
  };

  toggle.addEventListener('click', () => {
    if (drawer.classList.contains('is-open')) close();
    else open();
  });

  backdrop?.addEventListener('click', close);
  drawer.querySelector('[data-af-nav-close]')?.addEventListener('click', close);

  drawer.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', close);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();